import React, {
	useEffect,
	useCallback,
	useState
} from 'react';
import PropTypes from 'prop-types';
import {
	useAtom
} from 'jotai';

import {
	makeStyles
} from '@material-ui/core';

import Fido from "../utils/Fido";
import {patternsChangedAtom} from "../data/atoms/patterns";
import {SmallerTabV2} from "../components/SmallerTabs";

const styles = makeStyles(theme => ({
	wrapper: {
		position: 'relative'
	},

	indicator: {
		right: 3,
		position: 'absolute',
		width: theme.spacing(1),
		height: theme.spacing(1),
		top: theme.spacing(1.5),
		borderRadius: theme.spacing(1),
		backgroundColor: theme.palette.secondary.mustard
	}
}));

function PatternsTab(props) {
	const [checking, setChecking] = useState(false);
	const [changed, setChanged] = useAtom(patternsChangedAtom);

	let classes = styles(),
		{label, className, clickHandler, history} = props;

	const checkForNew = useCallback(() => {
		let bowser = new Fido();
		(async () => {
			let data = await bowser.fetch("/patterns/has-changes")
				.catch(error => {
					return console.log(error.message);
				});

			if (data) {
				setChanged(data);
			}
		})();
	}, [setChanged]);

	// first load, check for new
	useEffect(() => {
		checkForNew();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		history.listen((location, action) => {
			if (action !== 'REPLACE') {
				setChecking(true);
			}
		});
	}, [history, setChecking]);

	useEffect(() => {
		// history route has changed, need to check for new
		if (checking === true) {
			setChecking(false);
			// reset inactivePatterns
			setChanged({...changed, ...{inactivePatterns: false}});
			checkForNew();
		}
	}, [checking, checkForNew, changed, setChanged]);

	const clicked = (ev) => {
		clickHandler(ev, "patterns");
	};

	return (
		<div className={classes.wrapper}>
			<SmallerTabV2
				{...props}
				label={label}
				className={className}
				onClick={clicked} />
			{changed.changed ? <div className={classes.indicator} /> : null}
		</div>
	);
}

PatternsTab.propTypes = {
	label: PropTypes.string,
	className: PropTypes.string,
	clickHandler: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
	showSnackbar: PropTypes.func
};

export default PatternsTab;